import {dateWordShort} from "helper/helper";
import UseContext from "hooks/useContext";
import UseModal from "components/modal/useModal";
import Badge from "../../badge/badge";
import RatingTempWorker from "../../ratingTempWorker/ratingTempWorker";
import Tooltip from "../../tooltips/Tooltips";
import {useState} from "react";
import TableCell from "./TableCell";
import PerimeterName from "components/perimeterFilter/PerimeterName";
import { Check, ShowPassword } from "assets/icons";
import { useScrollContext } from "./ScrollableTableWrapper";
import {formatFirstname, formatFullName} from "helper/personName";


const Tbodyhours = ({champsBody, showPerimeter = false}) => {
    const {setObjID, roleUser, setIdTempWorker, setIdMission, setIdTimeSheet} = UseContext()
    const {toggle} = UseModal()
    const [selectedId, setSelectedId] = useState(null);
    const { hasMoved } = useScrollContext();
    let nbTutoDisplay = 0;

    const statusTextDay = {
        1: 'Vérifier',
        2: 'Litige',
        3: 'Complet',
    }
    const statusColorDay = {
        1: 'ALERT',
        2: 'WARNING',
        3: 'VALID',
    }

    const handleModal=(e,i)=>{
        e.preventDefault()
        setObjID(i)
        toggle('ts_toBeChecked')
    }

    const handleModalConsult=(e,i)=>{
        e.preventDefault()
        setObjID(i)
        toggle('ts_checked')
    }

    const handleRowClick = (item) => {
        // Empêcher le clic si on vient de faire un drag
        if (hasMoved) {
            return;
        }
        
        setSelectedId(item._id);
        // Ouvrir le modal du relevé d'heures complet
        if (item.validated === 1 && roleUser !== '200') {
            handleModal({ preventDefault: () => {} }, item._id);
        } else {
            handleModalConsult({ preventDefault: () => {} }, item._id);
        }
    }

    const handleCellClick = (e, item) => {
        e.stopPropagation();
        // Empêcher le clic si on vient de faire un drag
        if (hasMoved) {
            return;
        }
        
        setSelectedId(item._id);
        // Ouvrir le modal de notation de l'intérimaire
        if (item.user[0]?._id) setIdTempWorker(item.user[0]._id);
        if (item.mission[0]?._id) setIdMission(item.mission[0]._id);
        if (item._id) setIdTimeSheet(item._id);
        toggle('rating_temp_worker');
    }

    return (
        <>
            {champsBody?.map(item => {
                const isSelected = selectedId === item._id;
                return (
                <tr 
                    key={item._id} 
                    className={`${isSelected ? 'bg-yellow-50' : 'hover:bg-gray-50'} cursor-pointer transition-colors`}
                    onClick={() => handleRowClick(item)}
                >
                    <td className={'py-5 text-gray-900'}>{item.id_time_sheet}</td>
                    <td className={'py-5'}>
                        <div className={'text-gray-900'}>{item.mission[0].title}</div>
                        <div>n°{item.mission[0].id_mission}</div>
                    </td>
                    <td className={'py-5'}>
                        <Tooltip text={`Retravailler avec ${formatFirstname(item.user[0]?.firstname)}`} placement="top">
                            <div 
                                className={`inline-flex gap-2 items-center px-2 py-1 rounded transition-colors cursor-pointer ${isSelected ? 'hover:bg-yellow-100' : 'hover:bg-gray-100'}`}
                                onClick={(e) => handleCellClick(e, item)}
                            >
                                <span className={'underline decoration-dashed'}>
                                    {formatFullName(item.user[0]?.firstname, item.user[0]?.lastname)}
                                </span>
                                <div onClick={(e) => e.stopPropagation()}>
                                    <RatingTempWorker review={item.review} isTutoCanBeDisplayed={nbTutoDisplay === 0} idMission={item.mission[0]._id} idTempWorker={item.user[0]?._id} idTimeSheet={item._id}/>
                                    {(() => {
                                        nbTutoDisplay++;
                                        return null;
                                    })()}
                                </div>
                            </div>
                        </Tooltip>
                    </td>
                    <td className={'py-5'}>{dateWordShort(item.periode_start)} > {dateWordShort(item.periode_end)}</td>
                    {showPerimeter && (
                        <td className={'py-5'}>
                            <PerimeterName perimeter={item.perimeter}/>
                        </td>
                    )}
                    <td className={'py-5'}>
                        <div className="flex items-center justify-center">
                            {item.validated === 1 && roleUser !=='200' ?
                            <div className={'cursor-pointer'} onClick={(e) => {
                                e.stopPropagation();
                                handleModal(e,item._id)
                            }}>
                                <Badge type={statusColorDay[item.validated]}>{statusTextDay[item.validated]}</Badge>
                            </div>
                            :
                            <div className={'cursor-pointer'} onClick={(e) => {
                                e.stopPropagation();
                                handleModalConsult(e,item._id)
                            }}>
                                <Badge type={statusColorDay[item.validated]}>{statusTextDay[item.validated]}</Badge>
                            </div>
                            }
                        </div>
                    </td>
                    <TableCell
                        position="last"
                        hasButton
                        buttonOnClick={(e) => {
                            e.stopPropagation();
                            if ((item.validated === 1 || item.validated === 2) && roleUser !== '200') {
                                handleModal(e, item._id);
                            } else {
                                handleModalConsult(e, item._id);
                            }
                        }}
                        buttonContent={
                            (item.validated === 1 || item.validated === 2) && roleUser !== '200' ? (
                                <Check wh={24} color="#374151" />
                            ) : (
                                <ShowPassword wh={24} color="#374151" strokeW={2} />
                            )
                        }
                        buttonTooltip={
                            (item.validated === 1 || item.validated === 2) && roleUser !== '200'
                                ? 'Vérifier les heures'
                                : 'Consulter'
                        }
                    />
                </tr>
                );
            })}
        </>
    );
};

export default Tbodyhours;